export default {
  namespaced: true,
  state: {
    currentStepStatus: null,
  },
  getters: {
    getCurrentStepStage: state => state.currentStepStatus,
  },
  mutations: {
    SET_CURRENTSTEP_STAGE (state, value) {
      state.currentStepStatus = value
    },
  },
  actions: {

  }
}